// pdf.js, loaded on demand: only presenter-driven PDFs (and the activity
// form, to count their pages) need it - an <iframe> can't be told which
// page to show, and most mobile browsers can't render one inline anyway.
let lib = null;

async function pdfjs() {
    if (!lib) {
        lib = await import(/* webpackChunkName: "pdfjs" */ 'pdfjs-dist/legacy/build/pdf');
        lib.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/legacy/build/pdf.worker.min.js', import.meta.url).toString();
    }
    return lib;
}

export async function loadPdf(url) {
    const { getDocument } = await pdfjs();
    return getDocument({ url, isEvalSupported: false }).promise;
}

// null when it can't be read (bad URL, or another site without CORS).
export async function countPdfPages(url) {
    try {
        const doc = await loadPdf(url);
        const pages = doc.numPages;
        doc.destroy();
        return pages;
    } catch (error) {
        console.warn('No se ha podido leer el PDF:', error);
        return null;
    }
}
